import { withOnClickTracking } from 'auto-tracking';

import { styled, theme } from '../stitches.config';
import { rem } from '../util';

export const H1 = styled('h1', {
  color: theme.colors.blue12,
  fontFamily: theme.fonts.serif,
  fontSize: rem(45),
  fontWeight: theme.fontWeights.bold,
  lineHeight: rem(56),
  marginTop: 0,
  marginBottom: 0,
});

export const H2 = styled('h2', {
  color: theme.colors.blue12,
  fontFamily: theme.fonts.serif,
  fontSize: rem(31),
  fontWeight: theme.fontWeights.semiBold,
  lineHeight: rem(40),
  marginTop: 0,
  marginBottom: 0,
});

export const H3 = styled('h3', {
  color: theme.colors.blue12,
  fontFamily: theme.fonts.sansSerif,
  fontSize: rem(20),
  lineHeight: rem(24),
  fontWeight: theme.fontWeights.medium,
  marginTop: 0,
  marginBottom: 0,
});

export const H4 = styled('h4', {
  color: theme.colors.blue12,
  fontFamily: theme.fonts.sansSerif,
  fontSize: rem(14),
  lineHeight: rem(24),
  fontWeight: theme.fontWeights.medium,
  marginTop: 0,
  marginBottom: 0,
});

export const H6 = styled('h6', {
  color: theme.colors.blue12,
  fontFamily: theme.fonts.sansSerif,
  fontSize: rem(16),
  lineHeight: rem(24),
  fontWeight: theme.fontWeights.medium,
  marginTop: 0,
  marginBottom: 0,
});

export const P = styled('p', {
  color: theme.colors.gray11,
  fontFamily: theme.fonts.sansSerif,
  fontSize: rem(16),
  lineHeight: rem(24),
  margin: 0,
  overflowWrap: 'break-word',

  variants: {
    color: {
      default: {},
      blue: {
        color: theme.colors.blue12,
      },
      error: {
        color: theme.colors.red11,
      },
    },
    weight: {
      medium: {
        fontWeight: theme.fontWeights.medium,
      },
      semiBold: {
        fontWeight: theme.fontWeights.semiBold,
      },
      bold: {
        fontWeight: theme.fontWeights.bold,
      },
    },
    size: {
      tiny: {
        fontSize: rem(12),
        lineHeight: rem(16),
      },
      small: {
        fontSize: rem(14),
      },
      medium: {
        fontSize: rem(18),
      },
      big: {
        fontSize: rem(21),
        lineHeight: rem(32),
      },
    },
    noWrap: {
      true: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
      },
      false: {},
    },
  },

  defaultVariants: { noWrap: 'false' },
});

export const Strong = styled('strong', {
  variants: {
    color: {
      default: {},
      heading: {
        color: theme.colors.gray11,
      },
    },
    weight: {
      medium: {
        fontWeight: theme.fontWeights.medium,
      },
    },
  },
});

export const Text = styled('span', {});

export const A = withOnClickTracking(
  styled('a', {
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'none',
    },

    variants: {
      color: {
        white: {
          color: theme.colors.white,
        },
        blue: {
          color: theme.colors.blue11,
        },
        inherit: {
          color: 'inherit',
        },
      },
    },

    defaultVariants: {
      color: 'blue',
    },
  }),
);

export const Strike = styled('span', {
  textDecoration: 'line-through',
});
